export const FIRE = 'fire';
export const WATER = 'water';
export const EARTH = 'earth';
export const AIR = 'air';

export const elementalDisplayNames = {
  [FIRE]: 'Feuer',
  [WATER]: 'Wasser',
  [EARTH]: 'Erde',
  [AIR]: 'Luft',
};

export const DOMAIN = process.env.REACT_APP_DOMAIN || 'http://localhost:3000';
